/*
**  aqui são armazenados os segementos selecionados na tela de compras
*/

const state = {
  itens: []
}

const getters = {
  getItens(state) {
    return state.itens
  }
}

const mutations = {
  adicionarTodos(state, segmentos) {
    state.itens = segmentos
  },
  adicionar(state, segmento) {
    state.itens.push(segmento)
  },
  remover(state, segmento) {
    state.itens = state.itens.filter(item => item !== segmento)
  },
  resetar(state) {
    state.itens = []
  }
}

const actions = {
  adicionarTodos: ({ commit }, segmentos) => {
    commit("adicionarTodos", segmentos)
  },
  adicionar: ({ commit }, segmento) => {
    commit("adicionar", segmento)
  },
  remover: ({ commit }, segmento) => {
    commit("remover", segmento)
  },
  resetar: ({ commit }) => {
    commit("resetar")
  }
}

export default { namespaced: true, state, mutations, getters, actions }
